// import './breadCrumb.scss';

import {FunctionalComponent, h} from "preact";
import {useContext} from "preact/hooks";
import {LocalizationContext} from "../app";
import {log} from "../libs/QuerloLogger";

export const OfflineDialog: FunctionalComponent<{ offline: any; reconnectCB: () => void }> = ({offline, reconnectCB}) => {
  const {t} = useContext(LocalizationContext);
  
  const content = offline ? <div>
    <h1>{t('You are offline')}</h1>
    <p>{t('Please reconnect to a network.')}</p>
  </div> : <div>
    <h1>{t('Chat not connected')}</h1>
    <p>{t('Please click here to connect')}</p>
    <button className="primary" onClick={reconnectCB}>{t('Connect')}</button>
  </div>
  
  return (
    <dialog className="offline dialog" open>
      { content }
    </dialog>
  );
};
